import RegisterForm from '@/components/auth/RegisterForm.tsx';
import Logo from '@/components/shared/Logo.tsx';
import LanguageSelector from '@/components/shared/LanguageSelector.tsx';
import ThemeToggle from '@/components/shared/ThemeToggle.tsx';

export default function RegisterPage() {
  return (
    <div className="min-h-screen bg-card">
      <nav className="sticky top-0 z-40 border-b border-border bg-card/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo size="md" linkTo="/" />
          <div className="flex items-center gap-2">
            <LanguageSelector />
            <ThemeToggle />
          </div>
        </div>
      </nav>
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center px-4 py-8">
        <RegisterForm />
      </div>
    </div>
  );
}
